import { useEffect, useState } from "react"
import { type ITapLevel, probeTapLevels } from "../../lib/system-audio"
import type { IProps } from "./interfaces"
import { SystemAudioPickerView } from "./SystemAudioPickerView"

/**
 * Smart wrapper for the system-audio output picker. While open, it probes the
 * outputs' peak levels frequently so the per-output meters move in near-real-time
 * ("pick the one that moves"). Stops probing when closed. The dumb
 * `SystemAudioPickerView` renders it.
 */
export const SystemAudioPicker = ({ opened, targets, currentId, onSelect, onClose }: IProps): React.JSX.Element => {
  const [levels, setLevels] = useState<ITapLevel[]>([])

  useEffect(() => {
    if (!opened) {
      setLevels([])
      return
    }
    let cancelled = false
    let timer: ReturnType<typeof setTimeout> | null = null

    const tick = async (): Promise<void> => {
      const next = await probeTapLevels(300)
      if (cancelled) return
      setLevels(next)
      timer = setTimeout(tick, 250)
    }
    void tick()

    return (): void => {
      cancelled = true
      if (timer) clearTimeout(timer)
    }
  }, [opened])

  return (
    <SystemAudioPickerView
      opened={opened}
      targets={targets}
      levels={levels}
      currentId={currentId}
      onSelect={onSelect}
      onClose={onClose}
    />
  )
}
